
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.095 6.06L.97 1.933A.833.833 0 012.148.756L6.863 5.47a.833.833 0 010 1.178l-4.715 4.715A.833.833 0 01.97 10.184L5.095 6.06z","fill":"#7E8186"}})])
          )
        }
      }
    